import './CommentCreateButton.css'
import React from 'react'
import formatMessage from 'format-message'
import classnames from 'classnames'

export default function CreateComment({ isVisible, left, onCreateComment, top, annotationId }) {
  const classes = classnames('Comment-create', {
    'Comment-create--visible': isVisible,
  })

  return (
    <button
      aria-label={formatMessage('Create comment')}
      aria-hidden={!isVisible}
      className={classes}
      data-original-top={top}
      onClick={() => onCreateComment()}
      onTouchStart={(event) => event.stopPropagation()}
      style={{
        top: `${top - 10}px`,
        left: `${left - 24}px`,
        position: isVisible ? 'absolute' : 'fixed',
        visibility: isVisible ? 'visible' : 'hidden',
      }}
      id={`${annotationId}-comment-create-button`}
      tabIndex={isVisible ? 0 : -1}
    >
      <img
        src="/images/icons/create-comment-icon.svg"
        style={{ width: '24px', height: '24px' }}
        alt={formatMessage('Create comment icon')}
      />
    </button>
  )
}
